import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungKarlsruhe() {
  return (
    <CityPageTemplate
      city="Karlsruhe"
      slug="karlsruhe"
      intro="In der Technologieregion Karlsruhe sollte auch Deine Finanzplanung auf dem neuesten Stand sein."
      description="Unabhängige & digitale Finanzberatung für Karlsruhe: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
